
import Pusher from "pusher-js";
import { useCallback, useEffect, useRef } from "react";

const baseUrl = process.env.REACT_APP_API_ENDPOINT;
const pusherCluster = process.env.REACT_APP_PUSHER_CLUSTER;
const pusherKey = process.env.REACT_APP_PUSHER_KEY ?? "";

export default function usePusher({accessKey, channelName, endpoint, firstRun, handlers, skip}) {
  const pusherStream = useRef({});
 
  const initPusherAuth = useCallback(async(channelName, handlers, endpoint) => {
    if (!pusherStream.current[channelName]) {
      const origin = window.location.href
      const pusher = new Pusher(pusherKey, {
        authEndpoint: `${baseUrl}/${endpoint}`,
        cluster: pusherCluster,
        auth: {
          params: { channelName },
          headers: { authorization: accessKey, origin },
        },
      });
      const currentSub = pusher.subscribe(channelName)
      pusherStream.current = {...pusherStream.current, [channelName]: currentSub};

      const binders = Object.keys(handlers);
      Array.isArray(binders) && binders?.forEach((binding) => {
        if(handlers[binding]?.register) {
          pusherStream?.current[channelName]?.bind(binding, handlers[binding]?.do)
        }
      })
    }  else {
    }
  }, [accessKey]);
  
  useEffect(() => {
    if(!skip) {
      if(accessKey) {
        typeof firstRun === "function" && firstRun()
        initPusherAuth(channelName, handlers, endpoint)
      }
    }
    return () => {
      const bindings = Object.keys(pusherStream.current);
      Array.isArray(bindings) && bindings?.forEach((binding) => {
        pusherStream.current[binding] && pusherStream.current[binding].unsubscribe(binding);
      })
      pusherStream.current = {}
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [skip, accessKey])

  return null
}
